module.exports = __webpack_public_path__ + "static/img/product_ultra.b6a7d3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product_ultra.jpg
// module id = llwU
// module chunks = 1